import React, { useState } from "react";
import TogglerBody from "../TogglerBody";
import FlagCustomisationItemCounter from "./FlagCustomisationItemCounter";
import FlagCustomisationItem from "./FlagCustomisationItem";
import SquareIcon from "../SquareIcon/SquareIcon";
import "./flagCustomisation.scss";

  const flagItemArrTips = [
    {
      title: "Repeated Text",
      keyName: "repeatedPunishment",
      sliderKeyName: "repeatedSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Repeated Text action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send <span> 1.27 </span> repeated messages before getting <span> Revoke Roles </span>. </p>",
    },
    {
      title: "Z̴̞͝a̵̞̐l̴̘̏g̵̘̈́o̴̻͆  Text",
      keyName: "zalgoPunishment",
      sliderKeyName: "zalgoSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Zalgo Text action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send <span> 1 </span> Zalgo characters before getting <span> Log </span>. </p>",
    },
    {
      title: "External Links",
      keyName: "externalPunishment",
      sliderKeyName: "externalSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Image Attachment action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send <span> 1 </span> images before getting <span> Warn </span>. </p>",
    },
    {
      title: "Server Invites",
      keyName: "invitesPunishment",
      sliderKeyName: "invitesSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Links Sending action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send<span> 3.52 </span> links before getting <span> Warn </span>. </p>",
    },
    {
      title: "Images",
      keyName: "imagesPunishment",
      sliderKeyName: "imagesSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Invite Sending action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send <span> 1.9 </span> nvites before getting <span> Ban </span>. </p>",
    },
    {
      title: "Files",
      keyName: "filesPunishment",
      sliderKeyName: "filesSensitivity",
      tipsTitle: "Sensitivity",
      label: "Dangerous",
      text: "<p>Set the sensitivity for Files Attachment action. Define the number of messages a user needs to send before Themis takes action.</p>",
      textSecond:
        "<p>A member approximately needs to send <span> 1.00 </span> files before getting <span> Revoke Roles </span>. </p>",
    },
  ]

const FlagCustomisation = ({ title, text, data }) => {
  const [isCustommisation , setIsCustommisation] = useState(data?.enabled);

  const isTitle = true;
  return (
    <div className="advance_seting_with_title_wrap">
      {isTitle && (
        <div className="overview_component_content_head">
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
      )}
      <div className="status_block_wrap flag_customisation_wrap">
        <div className="status_block_wrap_bg"></div>
        <SquareIcon
          squareFirstClassname={"first_square_bg_blue"}
          squareSecondClassname={"second_square_bg_blue"}
          imgSrc={"/img/FlagSettingsIcon.svg"}
        />
        {/* <img  className='status_block_wrap_img' src="/img/FlagSettings.svg" alt="" /> */}
        <h3>Flag Customisation</h3>
        <div
          className="status_block_item"
          style={{ borderBottom: "1px solid #8D99A3" }}
        >
          <div className="status_block_item_toggler">
            <TogglerBody isOn={isCustommisation} setIsOn={setIsCustommisation} keyName={"enabled"} advance />
            <p>Use advanced parameters</p>
          </div>
        </div>
        <div className="status_block_item flag_customisation_wrap_block_plug">
          <div
            className={`status_block_item flag_customisation_wrap_block ${
              isCustommisation ? "" : "flag_customisation_wrap_block_blur"
            }`}
          >
            {flagItemArrTips.map((item, idx) => (
              <FlagCustomisationItem key={idx} item={item} data={data} />
            ))}
          </div>
          {!isCustommisation && (
            <div className="flag_customisation_wrap_plug">
              <p>Enable Advanced Parameters 🙏🏻</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlagCustomisation;
